import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IframeCategoryItem, ISettingsMenu } from '@atlas-workspace/shared/models';

import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { OptionsIframeService } from '../services/options-iframe.service';


@Component({
  selector: 'atl-iframe-introduction',
  templateUrl: './options-introduction.component.html',
  styleUrls: ['./options-introduction.component.scss'],
})

export class OptionsIframeIntroductionComponent implements OnInit {
  public introduction$!: Observable<IframeCategoryItem | null>;

  constructor(
    private readonly optionsService: OptionsIframeService,
    private readonly router: Router,
  ) { }

  ngOnInit(): void {
    this.introduction$ = this.optionsService.introduction$;
  }

  public openFirstCategory(): void {
    this.optionsService.optionCategories$.pipe(take(1)).subscribe((result: ISettingsMenu[]) => {
      const link = result[1].route;
      void this.router.navigate([link]);
    });
  }

}
